import React from 'react'
// css
import style from './managementIndicators/PanelIndicators.css'
let PropTypes = React.PropTypes

class HeaderFiltro extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            filtering: false,
            filtro: []
        }

    }
    // Metodos para controlar el display del menu, ocultar y mostrar los elementos
    componentDidMount() {
        document.addEventListener('click', this.onClickHandler.bind(this))
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onClickHandler.bind(this))
    }
    onClickHandler(evt) {
        // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
        if (!this.node.contains(evt.target) && this.state.filtering)
            this.cerrarMenu_descartarCambios()
    }

    toggleMenu() {
        const clientes = this.props.indicators ? this.props.indicators.map((aux) => {
            return aux.client_name
        }) : []
        const clientesUnicos = clientes.filter((item, i, ar) => ar.indexOf(item) === i);
        const clientesFiltro = clientesUnicos.map((aux) => {
            return {
                texto: aux,
                seleccionado: true,
            }
        })
        if (this.state.filtering) {
            this.cerrarMenu_descartarCambios()
        } else {
            this.setState({ filtering: true })
            if (this.props.sinFiltro) {
                this.setState({
                    filtro: clientesFiltro
                })
            }
            else if (this.state.filtro.length == 0) {
                this.setState({
                    filtro: clientesFiltro
                })
            }
        }
    }
    cerrarMenu_descartarCambios() {
        this.setState({
            filtering: false,
            filtro: []
        })
    }
    cerrarMenu_aplicarCambios() {
        // ocultar el menu e informar la actualizacion del filtro al padre
        this.setState({ filtro: this.state.filtro, filtering: false })
        this.props.actualizarFiltro(this.state.filtro)
        //console.log(this.state.filtro)
    }
    onClickHandler(evt) {
        // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
        if (!this.node.contains(evt.target) && this.state.filtering)
            this.cerrarMenu_descartarCambios()
    }
    seleccionarOpcion(valorSeleccionado) {
        this.setState({
            filtro: this.state.filtro.map(opcion => {
                return {
                    // si es la opcion que estamos buscando, se cambia su estado 'seleccionado', si no lo dejamos igual
                    texto: opcion.texto,
                    seleccionado: opcion.texto == valorSeleccionado ? !opcion.seleccionado : opcion.seleccionado,

                }
            })
        })
    }
    estanTodosSeleccionados() {
        // todos seleccionados = el total de '.selecconado=false' es cero
        return this.state.filtro.filter(opc => opc.seleccionado === false).length === 0
    }
    toggleTodos() {
        let todosSeleccionados = this.estanTodosSeleccionados()
        this.setState({
            filtro: this.state.filtro.map(opcion => {
                return {
                    // si estan todos seleccionados, marcar ninguno
                    // si falta uno por marcar, se marcan todos
                    seleccionado: !todosSeleccionados,
                    texto: opcion.texto,
                }
            })
        })
    }
    onKeyDownInputTexto(evt) {
        // 13 = enter
        if (evt.keyCode === 13) {
            // tanto al texto buscado, como el de los input, se la quitan los espacios y se pone en minusculas
            let texto = this.refInputTexto.value.trim().toLowerCase()

            let filtroActualizado = this.state.filtro.map(opcion => {
                let textoOpcion = opcion.texto.trim().toLowerCase()

                // Si se realiza una "busqueda exacta" se comparan los string, de lo contrario
                // busca que este incluido en el texto
                opcion.seleccionado = this.props.busquedaExacta ? textoOpcion == texto : textoOpcion.includes(texto)
                return opcion
            })
            // luego de buscar, se oculta la busqueda
            this.refInputTexto.value = ''
            // this.closeMe nu()
            this.setState({ filtering: false })

            // informar la actualizacion al padre
            this.props.actualizarFiltro(filtroActualizado)
        }
    }
    render() {
        return (
            <div className={style.container}
                ref={ref => this.node = ref}>
                <div className={style.divTitulo}
                    onClick={this.toggleMenu.bind(this)}>
                    {this.props.nombre}
                </div>
                <div className={'pull-right'}>
                    {this.props.ordenarLista ?
                        <span className={'glyphicon glyphicon-sort-by-attributes ' + style.spanOrdenar}
                            onClick={this.props.ordenarLista}
                        /> : null
                    }
                    <span className={
                        (this.estanTodosSeleccionados() ? '' : style.filtroColoreado) +
                        (this.state.filtering ? ' glyphicon glyphicon-triangle-top ' : ' glyphicon glyphicon-triangle-bottom ')
                    }
                        onClick={this.toggleMenu.bind(this)}
                    />
                </div>
                <div className={style.menu} style={{ display: this.state.filtering ? '' : 'none' }}>
                    {/* Buscar por texto */}
                    {/*<input type="text" className={style.inputTexto}
                        placeholder="Filtrar por..."
                        ref={ref => this.refInputTexto = ref}
                        onKeyDown={this.onKeyDownInputTexto.bind(this)}
                />*/}
                    {/* Lista de Opciones */}
                    <div className={style.contenedorValores}>
                        {this.state.filtro.map((opcion, index) =>
                            <label key={index}>
                                <input type="checkbox"
                                    onChange={this.seleccionarOpcion.bind(this, opcion.texto)}
                                    checked={!!opcion.seleccionado}
                                /> {opcion.texto}
                            </label>

                        )}
                    </div>
                    {/* Seleccionar todos */}
                    <label>
                        <input type="checkbox"
                            onChange={this.toggleTodos.bind(this)}
                            checked={this.estanTodosSeleccionados.call(this)}
                        />Todos
                    </label>
                    {/* Boton Buscar */}
                    <a href="#"
                        className="btn btn-block btn-sm btn-primary"
                        onClick={this.cerrarMenu_aplicarCambios.bind(this)}>
                        Aceptar
                    </a>
                </div>
            </div>
        )
    }
}

export default HeaderFiltro


// WEBPACK FOOTER //
// ./frontEnd/home/components/HeaderFiltro.jsx